import type { ComputedRef } from 'vue'
import { computed } from 'vue'
import { useStore } from 'vuex'

/**
 * The promoter's region-settings currency symbol.
 *
 * This is the fallback for money that carries no currency of its own — where a
 * value has its own currency, prefer `resolveCurrencySymbol(code, fallback)`
 * from `@/utils/constants`.
 *
 * The store access is guarded because several components using this are unit
 * tested without a vuex store installed, where `useStore()` returns undefined.
 */
export function useCurrencySymbol(): ComputedRef<string> {
  const store = useStore()
  return computed(() => store?.getters?.['authModule/regionSettingsCurrencySymbol'] || '$')
}
